<template>
<div class="ma-0 pa-0">
  <v-dialog content-class="rounded-v-dialog" persistent attach :value="show" max-width="750" width="600" id="member-dialog">
    <v-card class="relative add-edit-wrapper">
      <div class="close-btn">
        <i class="material-icons" @click="handleClose">
          clear
        </i>
      </div>

      <v-card-title class="pb-2  headline dark-text justify-center">{{ mode }} Profile</v-card-title>
      <v-row justify="center" class="pt-3 ml-3">
              <v-list-item-avatar size="95">
              <img :src="user.picture" @error="getAvatarUrl($event, user.name)">
            </v-list-item-avatar>

            </v-row>
            <v-icon
              style="
                position: absolute;
                top: 3em;
                left: 5.2em;
                pointer: cursor;
              "
              @click="showImageUpload=!showImageUpload"
              size="45"
            >
              mdi-circle
            </v-icon>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  style="
                    position: absolute;
                    top: 4.75em;
                    left: 8.05em;
                    pointer: cursor;
                  "
                  @click="showImageUpload=!showImageUpload"
                  size="30"
                  color="white"
                >
                  mdi-camera-outline
                </v-icon>
              </template>
              <span>Change Image</span>
            </v-tooltip>
      <v-container grid-list-xl fluid>
        <div>
          <v-form ref="form" class="org-assign-user-form" v-model="valid">
            <v-flex md12>
              <p class="input-label text-style">
                Name*
              </p>
              <v-text-field
                ref="username"
                v-model="name"
                class="select-field customInputRound"
                required
                solo
                outlined
              />
            </v-flex>
            <v-card-actions class="d-flex flex-column pa-0 mt-5">
              <div class="ma-0 pa-0" style="display:flex; width:80%">
                <div class="ma-0 pa-0" style="width:40%">
                  <v-btn
                    class="save-btn mb-16px"
                    @click="handleSave"
                    :disabled="!name"
                  >
                    Save
                  </v-btn>
                </div>
                <v-spacer></v-spacer>
                <div class="ma-0 pa-0" style="width:45%">
                  <v-btn
                    class="cancel-btn"
                    text
                    @click="handleClose"
                  >
                    Cancel
                  </v-btn>
                </div>
              </div>
            </v-card-actions>
          </v-form>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
  <image-upload
    field="picture"
    @crop-success="cropSuccess"
    v-model="showImageUpload"
    :width="200"
    :height="200"
    langType="en"
    img-format="png">
  </image-upload>
</div>
</template>

<script>
import { ROLES } from '../../../utils/constants'
import { mapGetters } from 'vuex'
import imageUpload from 'vue-image-crop-upload'
export default {
  name: 'editProfile',
  components: {
    imageUpload
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    currentOrganization: {
      type: Object,
      default: null
    },
    activeUser: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      profilePicture: '',
      showImageUpload: false,
      valid: false,
      name: null,
      email: null,
      role: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ],
      confirDialog: false,
      disabled: false
    }
  },
  computed: {
    roles () {
      const roles = [...ROLES]
      const role = this.user.role[this.currentOrganization.entity_id]
      role != 'owner' && roles.shift()
      return roles
    },
    mode () {
      return this.activeUser ? 'Edit' : 'Create'
    },
    ...mapGetters(['user'])
  },
  methods: {
    save () {
      // avatar_url field is removed when a profile_pic is uploaded
      const userData = {
        entity_id: this.user.entity_id,
        user_id: this.user.user_id,
        affiliate_id: JSON.parse(localStorage.getItem('reveles-user')).affiliate_id,
        email: JSON.parse(localStorage.getItem('reveles-user')).email,
        email_verified: this.user.email_verified,
        nickname: JSON.parse(localStorage.getItem('reveles-user')).nickname,
        blocked: false,
        name: this.username,
        picture: this.profilePicture,
        eula_accepted: true,
        tour_complete: !!this.user?.tour_complete
      }
      this.$store.dispatch('updateProfile', { data: userData, shouldReload: true })
    },
    cropSuccess (imgDataUrl) {
      this.profilePicture = imgDataUrl
      this.save()
    },
    handleSave () {
      if (!this.valid) return
      const payload = {
        entity_id: this.activeUser ? this.activeUser.user_id : undefined,
        name: this.name,
        email: this.email,
        role: this.role,
        organization_id: this.currentOrganization.entity_id
      }
      this.$refs.form.reset()
      this.handleClose()
      this.$emit('onSave', payload)
    },
    handleClose () {
      this.$emit('onClose')
    }

  },
  watch: {
    show (willShow) {
      if (willShow) {
        this.$nextTick(() => this.$refs.username.focus())
      }
      if (!willShow || !this.activeUser) {
        (this.$refs.form) && this.$refs.form.reset()
      } else if (willShow && this.activeUser) {
        if (typeof this.activeUser.role === 'object') this.role = this.activeUser.role[this.currentOrganization.entity_id]
        else if (typeof this.activeUser.role === 'string') this.role = this.activeUser.role
        this.name = this.activeUser.name
        this.email = this.activeUser.email
        this.disabled = this.user.user_id == this.activeUser.user_id
      }
    }
  }
}
</script>
<style lang="scss">
</style>
